import { render, staticRenderFns } from "./ChamberForm.vue?vue&type=template&id=f23b511a&"
import script from "./ChamberForm.vue?vue&type=script&lang=js&"
export * from "./ChamberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports